import http from '@/utils/http';

/**
 * 获取考勤规则列表-cyj
 */
export function getRuleList(data) {
    return http({
        url: '/api-lcrm/attendance/listRulePage',
        method: 'post',
        data
    });
};

/**
 * 删除考勤规则-cyj
 */
export function deleteApi(id) {
    return http.post('/api-lcrm/attendance/deleteRule', id, {
        headers: { 'Content-Type': 'application/json' }
    });
};

/**
 * 新增规则列表-cyj
 */
export const createRule = (data) => {
    return http({
        url: `/api-lcrm/attendance/saveRule`,
        method: 'post',
        data
    });
};

/**
 * 获取考勤打卡点列表-cyj
 */
export function getListLocation(data) {
    return http({
        url: '/api-lcrm/attendance/listLocationPage',
        method: 'post',
        data
    });
};

/**
 * 删除考勤打卡点-cyj
 */
export function deleteLocation(id) {
    return http.post('/api-lcrm/attendance/deleteLocation', id, {
        headers: { 'Content-Type': 'application/json' }
    });
};

/**
 * 创建考勤打卡点-cyj
 */
export const createLocation = (data) => {
    return http({
        url: `/api-lcrm/attendance/createLocation`,
        method: 'post',
        data
    });
};

// 修改考勤点数据-cyj
export const updateLocation = (data) => {
    return http({
        url: `/api-lcrm/attendance/updateLocation`,
        method: 'post',
        data
    });
};

/**
 * 根据条件查询组织列表 pz
 */
export const queryManageOrgList = (data) => {
    return http({
        url: `/api-lcrm/lcrm/org/info/selectByCondition`,
        method: 'post',
        data
    });
};
